function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _superPropGet(t, o, e, r) {
  var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e);
  return 2 & r && "function" == typeof p ? function (t) {
    return p.apply(e, t);
  } : p;
}
function _get() {
  return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
    var p = _superPropBase(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
    }
  }, _get.apply(null, arguments);
}
function _superPropBase(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t)););
  return t;
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
var GameTemplate = require('../../lib/templates/gametemplate');
var SettlersRules = require('./lib/ui/overlays/rules');
var SettlersStats = require('./lib/ui/overlays/stats');
var SettlersGameOptionsTemplate = require('./lib/ui/settlers-game-options.template');
var htmlTemplate = require('./lib/ui/game-html.template');
var AppSettings = require('./lib/ui/settlers-settings');
var SettlersGameLoop = require('./lib/src/settlers-gameloop.js');
var SettlersPlayer = require('./lib/src/settlers-player');
var SettlersActions = require('./lib/src/settlers-actions');
var SettlersDisplay = require('./lib/src/settlers-display');
var SettlersState = require('./lib/src/settlers-state');
var TradeOverlay = require('./lib/ui/overlays/trade');
var BuildOverlay = require('./lib/ui/overlays/build');
var BankOverlay = require('./lib/ui/overlays/bank');
var DevCardOverlay = require('./lib/ui/overlays/dev-card');
var YearOfPlentyOverlay = require('./lib/ui/overlays/year-of-plenty');
var DiscardOverlay = require('./lib/ui/overlays/discard');
var MonopolyOverlay = require('./lib/ui/overlays/monopoly');
var CardOverlay = require('./lib/ui/overlays/card');

//////////////////
// CONSTRUCTOR  //
//////////////////
var Settlers = /*#__PURE__*/function (_GameTemplate) {
  function Settlers(app) {
    var _this;
    _classCallCheck(this, Settlers);
    _this = _callSuper(this, Settlers, [app]);
    _this.app = app;
    _this.name = 'Settlers';
    _this.slug = 'settlers';
    _this.gamename = 'Settlers of Saitoa';
    _this.description = "Saitoa is an island rich in natural resources that are produced with every roll of the die. Collect, trade, and spend resources to grow your colony faster than your opponents to win the game!";
    _this.categories = 'Games Boardgame Strategy';
    _this.minPlayers = 2;
    _this.maxPlayers = 4;
    _this.game_length = 20; //Estimated number of minutes to complete a game
    _this.confirm_moves = true;
    _this.animationSpeed = 1200;
    _this.sleep_timer = null;
    _this.insert_rankings = true;

    //Deactivate screen record, but why?
    _this.recordOptions.active = false;

    //
    // UI components
    //
    _this.rules_overlay = new SettlersRules(_this.app, _this);
    _this.stats_overlay = new SettlersStats(_this.app, _this);
    _this.trade_overlay = new TradeOverlay(_this.app, _this);
    _this.card_overlay = new CardOverlay(_this.app, _this);
    _this.build = new BuildOverlay(_this.app, _this);
    _this.bank = new BankOverlay(_this.app, _this);
    _this.dev_card = new DevCardOverlay(_this.app, _this);
    _this.year_of_plenty = new YearOfPlentyOverlay(_this.app, _this);
    _this.discard = new DiscardOverlay(_this.app, _this);
    _this.monopoly = new MonopolyOverlay(_this.app, _this);

    //
    // basic game info
    //
    _this.empty = false;
    _this.c1 = {
      name: 'village',
      svg: "<img src=\"/settlers/img/icons/village3.png\"/>"
    };
    _this.c2 = {
      name: 'city',
      svg: "<img src=\"/settlers/img/icons/city3.png\"/>"
    };
    _this.r = {
      name: 'road',
      svg: "<img src=\"/settlers/img/icons/road.png\"/>"
    };
    _this.b = {
      name: 'bandit',
      icon: "<img src=\"/settlers/img/icons/bandit.png\"/>",
      alt: "<img src=\"/settlers/img/icons/robinhood.png\"/>",
      card: "<img src=\"/settlers/img/cards/devcards/bandit.png\"/>",
      alt_card: "<img src=\"/settlers/img/cards/devcards/robin_hood.png\"/>"
    };
    _this.s = {
      name: 'soldier',
      img: "<img class=\"image-as-token\" src=\"/settlers/img/icons/knight.png\"/>"
    };
    _this.t = {
      name: 'bank'
    };
    _this.vp = {
      name: 'VP',
      img: "<img src=\"/settlers/img/cards/devcard.png\"/>"
    };
    _this.longest = {
      name: 'Longest Road',
      icon: "<img class=\"image-as-token\" src=\"/settlers/img/icons/road.png\"/>",
      card: "<img src=\"/settlers/img/cards/longest_road.png\"/>",
      value: 2,
      min: 5
    };
    _this.largest = {
      name: 'Largest Army',
      card: "<img src=\"/settlers/img/cards/largest_army.png\"/>",
      value: 2
    };
    _this.resources = [{
      name: 'brick',
      count: 3,
      ict: 3,
      icon: '/settlers/img/icons/brick-icon.png'
    }, {
      name: 'wood',
      count: 4,
      ict: 3,
      icon: '/settlers/img/icons/wood-icon.png'
    }, {
      name: 'wheat',
      count: 4,
      ict: 3,
      icon: '/settlers/img/icons/wheat-icon.png'
    }, {
      name: 'wool',
      count: 4,
      ict: 3,
      icon: '/settlers/img/icons/wool-icon.png'
    }, {
      name: 'ore',
      count: 3,
      ict: 3,
      icon: '/settlers/img/icons/ore-icon.png'
    }, {
      name: 'desert',
      count: 1,
      ict: 1,
      "null": true
    }];
    _this.priceList = [['brick', 'wood'], ['brick', 'wood', 'wheat', 'wool'], ['ore', 'ore', 'ore', 'wheat', 'wheat'], ['ore', 'wool', 'wheat']];
    _this.cardDir = '/settlers/img/cards/';
    _this.back = '/settlers/img/cards/desert.png'; //Hidden Resource cards
    _this.card = {
      name: 'development',
      back: '/settlers/img/cards/devcard.png'
    };
    _this.deck = [{
      card: 'Soldier',
      count: 14,
      img: '/settlers/img/cards/devcards/knight.png',
      title: 'Soldier',
      subtitle: "move the ".concat(_this.b.name),
      text: " may move the ".concat(_this.b.name),
      action: 1
    }, {
      card: 'Windfall',
      count: 2,
      img: '/settlers/img/cards/devcards/unexpected_bounty.png',
      title: 'Windfall',
      subtitle: 'receive any two resources',
      text: ' collects two resources',
      action: 2
    }, {
      card: 'Legal Monopoly',
      count: 2,
      img: '/settlers/img/cards/devcards/monopoly.png',
      title: 'Legal Monopoly',
      subtitle: 'get resource from opponents',
      text: ' steals all of any resource',
      action: 3
    }, {
      card: 'Construction',
      count: 2,
      img: '/settlers/img/cards/devcards/road_construction.png',
      title: 'Road Construction',
      subtitle: 'build two roads',
      text: ' may build two roads at no cost',
      action: 4
    }, {
      card: 'Market',
      count: 1,
      img: '/settlers/img/cards/devcards/market.png',
      title: 'Achievement - Market',
      subtitle: 'gain one victory point',
      text: ' earns one Victory Point',
      action: 0
    }, {
      card: 'University',
      count: 1,
      img: '/settlers/img/cards/devcards/university.png',
      title: 'Achievement - University',
      subtitle: 'gain one victory point',
      text: ' earns one Victory Point',
      action: 0
    }, {
      card: 'Cathedral',
      count: 1,
      img: '/settlers/img/cards/devcards/cathedral.png',
      title: 'Achievement - Cathedral',
      subtitle: 'gain one victory point',
      text: ' earns one Victory Point',
      action: 0
    }, {
      card: 'Lighthouse',
      count: 1,
      img: '/settlers/img/cards/devcards/lighthouse.png',
      title: 'Achievement - Lighthouse',
      subtitle: 'gain one victory point',
      text: ' earns one Victory Point',
      action: 0
    }, {
      card: 'Laboratory',
      count: 1,
      img: '/settlers/img/cards/devcards/chemistry.png',
      title: 'Achievement - Chemistry Lab',
      subtitle: 'gain one victory point',
      text: ' earns one Victory Point',
      action: 0
    },
    //Pseudo-dev cards

    {
      card: 'Bandit',
      count: 0,
      img: '/settlers/img/cards/bandit.png',
      title: "Event - ".concat(_this.b.name),
      text: " moves the ".concat(_this.b.name),
      action: -1
    }, {
      card: 'Robin Hood',
      count: 0,
      img: '/settlers/img/cards/robin_hood.png',
      title: "Event - Robin Hood",
      text: " moves the ".concat(_this.b.name),
      action: -1
    }, {
      card: "Winner",
      count: 0,
      img: '/settlers/img/cards/governors_statue.png',
      title: "Governor's Statue",
      text: " is elected governor of Saitoa",
      action: -2
    }];
    _this.gametitle = 'Settlers of Saitoa';
    _this.winState = {
      name: 'elected governor',
      img: '/settlers/img/cards/governors_statue.png'
    };
    _this.rules = ["Gain 1 ".concat(_this.vp.name, "."), "Move the ".concat(_this.b.name, " to a tile of your choosing"), "Gain any two resources", "Collect all cards of a resource from the other players", "Build 2 ".concat(_this.r.name, "s")];

    //
    // complicated game engine variables
    //
    //
    _this.grace_window = 24;
    _this.enable_observer = false;
    _this.sort_priority = 1;
    return _this;
  }
  _inherits(Settlers, _GameTemplate);
  return _createClass(Settlers, [{
    key: "hasSettings",
    value: function hasSettings() {
      return true;
    }
  }, {
    key: "loadSettings",
    value: function loadSettings() {
      var container = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      if (!container) {
        this.overlay.show("<div class=\"module-settings-overlay\"><h2>".concat(this.gamename, " Settings</h2></div>"));
        container = ".module-settings-overlay";
      }
      var as = new AppSettings(this.app, this, container);
      as.render();
    }
  }, {
    key: "render",
    value: function () {
      var _render = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(app) {
        var _document$querySelect,
          _this2 = this;
        var i, player, _i, html, trade_btn, openTrade, _showPlayerBoxes;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if (this.browser_active) {
                _context.n = 1;
                break;
              }
              return _context.a(2);
            case 1:
              if (!this.initialize_game_run) {
                _context.n = 2;
                break;
              }
              return _context.a(2);
            case 2:
              _context.n = 3;
              return this.injectGameHTML(htmlTemplate());
            case 3:
              _context.n = 4;
              return _superPropGet(Settlers, "render", this, 3)([app]);
            case 4:
              this.racetrack.win = this.game.options.game_length;
              this.racetrack.title = 'Victory Points';
              this.racetrack.icon = "<i class=\"fa-solid fa-crown\"></i>";
              this.racetrack.players = [];
              for (i = 0; i < this.game.players.length; i++) {
                player = {
                  name: app.keychain.returnUsername(this.game.players[i]),
                  score: this.game.state.players[i].vp,
                  color: this.game.colors[i]
                };
                this.racetrack.players.push(player);
              }
              this.racetrack.render();
              this.menu.addMenuOption('game-game', 'Game');
              this.menu.addSubMenuOption('game-game', {
                text: 'How to Play',
                id: 'game-rules',
                "class": 'game-rules',
                callback: function callback(app, game_mod) {
                  game_mod.menu.hideSubMenus();
                  game_mod.rules_overlay.render();
                }
              });
              this.menu.addSubMenuOption('game-game', {
                text: 'Settings',
                id: 'game-settings',
                "class": 'game-settings',
                callback: function callback(app, game_mod) {
                  game_mod.loadSettings();
                }
              });
              this.menu.addSubMenuOption('game-game', {
                text: 'Stats',
                id: 'game-stats',
                "class": 'game-stats',
                callback: function callback(app, game_mod) {
                  game_mod.menu.hideSubMenus();
                  game_mod.stats_overlay.render();
                }
              });
              this.menu.addChatMenu();
              this.menu.render();
              this.log.render();
              this.hexgrid.render('.main');
              this.cardfan.render();
              this.cardfan.addClass('bighand');
              try {
                this.playerbox.render();

                //
                // This adds a class in the playerbox to attach color
                //

                for (_i = 1; _i <= this.game.players.length; _i++) {
                  this.playerbox.addClass("p".concat(this.game.colors[_i - 1], "-lite"), _i, 'game-playerbox'); /* add to root object so it can be inherited everywhere.*/
                  this.playerbox.addClass("p".concat(this.game.colors[_i - 1], "-lite"), _i, 'game-playerbox-head');
                }
                if (app.browser.isMobileBrowser(navigator.userAgent)) {
                  console.log('mobile environment');
                  this.hammer.render('#game-hexgrid');
                  //Prevent hud dragging in mobile
                  this.hud.draggable_whole = false;
                } else {
                  this.sizer.render();
                  this.sizer.attachEvents('#game-hexgrid');
                }

                //
                // Preliminary DOM set up, adding elements to display
                //
                this.addCitiesToGameboard();
                this.addPortsToGameboard();
                this.displayBoard();
                if (this.game.state.placedCity == null) {
                  $('.dark').css('backgroundColor', 'unset');
                }

                ///
                if (this.game.state.lastroll.length) {
                  this.playerbox.updateGraphics("<div class=\"last-roll\">".concat(this.returnDiceImage(this.game.state.lastroll[0])).concat(this.returnDiceImage(this.game.state.lastroll[1]), "</div>"), this.game.state.playerTurn);
                }
                if (this.game.state.playerTurn) {
                  this.playerbox.setActive(this.game.state.playerTurn);
                }
              } catch (err) {
                console.error('Intialize HTML: ' + err);
              }

              //
              // add the HUD so we can leverage it
              //
              this.hud.minWidth = 600;
              this.hud.maxWidth = 1;
              this.hud.render();
              this.status = [];

              //
              //Maybe we should standardize addClass() or classlist = [], for our UI components
              //
              (_document$querySelect = document.querySelector('#hud-body')) === null || _document$querySelect === void 0 || _document$querySelect.classList.add('saitoa');
              $('.hud-body .controls').appendTo('#hud');
              html = "<ul><li class=\"option enabled\" id=\"score\" title=\"view game statistics\"><i class=\"fa-solid fa-ranking-star\"></i></li>\n\t    \t<li class=\"option enabled\" id=\"trade\" title=\"trade with other players\"><i class=\"fa-solid fa-money-bill-transfer\"></i></li>\n\t    \t<li class=\"option\" id=\"bank\" title=\"trade with the bank\"><i class=\"fa-solid fa-building-columns\"></i></li>\n\t    \t<li class=\"option\" id=\"playcard\" title=\"play an action card\"><i class=\"fa-solid fa-person-running\"></i></li>\n\t    \t<li class=\"option\" id=\"spend\" title=\"build or buy\"><i class=\"fa-solid fa-screwdriver-wrench\"></i></li>\n\t    \t<li class=\"option enabled\" id=\"rolldice\"><i class=\"fa-solid fa-forward\"></i></li></ul>\n\t    \t";
              this.hud.updateControls(html);
              this.updateControls();
              if (this.game.state.placedCity) {
                $('.option').css('visibility', 'hidden');
              }

              //
              // hook up interactivity
              //
              if (!document.querySelector('.controls #score')) {
                _context.n = 6;
                break;
              }
              document.querySelector('.controls #score').onclick = function (e) {
                _this2.stats_overlay.render();
              };
              if (document.querySelector('.controls #playcard')) {
                document.querySelector('.controls #playcard').onclick = function (e) {
                  _this2.dev_card.render();
                };
              }
              if (document.querySelector('.controls #bank')) {
                document.querySelector('.controls #bank').onclick = function (e) {
                  _this2.bank.render();
                };
              }
              if (document.querySelector('.controls #spend')) {
                document.querySelector('.controls #spend').onclick = function (e) {
                  _this2.build.render();
                };
              }
              trade_btn = document.querySelector('.controls #trade');
              if (!(!trade_btn || this.game.over)) {
                _context.n = 5;
                break;
              }
              return _context.a(2);
            case 5:
              openTrade = function openTrade(e) {
                if (_this2.game.state.ads[_this2.game.player - 1].offer || _this2.game.state.ads[_this2.game.player - 1].ask) {
                  _this2.showTradeOverlay(_this2.game.player, _this2.game.state.ads[_this2.game.player - 1].ask, _this2.game.state.ads[_this2.game.player - 1].offer);
                } else {
                  _this2.trade_overlay.render();
                }
              };
              trade_btn.onclick = openTrade;
              if (this.app.browser.isMobileBrowser() && window.innerHeight > window.innerWidth) {
                trade_btn.innerHTML = "<i class=\"fa-solid fa-users\"></i>";
                _showPlayerBoxes = function showPlayerBoxes() {
                  if (document.querySelector('.game-playerbox-manager').style.display == 'flex') {
                    document.querySelector('.game-playerbox-manager').style.display = 'none';
                    trade_btn.onclick = _showPlayerBoxes;
                    trade_btn.innerHTML = "<i class=\"fa-solid fa-users\"></i>";
                    return;
                  } else {
                    document.querySelector('.game-playerbox-manager').style.display = 'flex';
                    try {
                      // Swap to trade functionality

                      trade_btn.innerHTML = "<i class=\"fa-solid fa-money-bill-transfer\"></i>";
                      trade_btn.onclick = openTrade;

                      //
                      // close playerboxen on back-click
                      //
                      $('.game-playerbox-manager').off();
                      $('.game-playerbox-manager').on('click', function () {
                        console.log('Hide playerboxes in mobile');
                        document.querySelector('.game-playerbox-manager').style.display = 'none';
                        trade_btn.onclick = _showPlayerBoxes;
                        trade_btn.innerHTML = "<i class=\"fa-solid fa-users\"></i>";
                      });
                    } catch (err) {
                      console.error('ERROR 485023: ' + err);
                    }
                  }
                };
                trade_btn.onclick = _showPlayerBoxes;
              }
            case 6:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function render(_x) {
        return _render.apply(this, arguments);
      }
      return render;
    }()
  }, {
    key: "initializeGame",
    value: function initializeGame(game_id) {
      if (this.game.state == undefined) {
        this.game.state = this.initializeState();
        this.game.canProcess = false; // For end game... 

        if (!this.game.colors) {
          var colors = [1, 2, 3, 4];
          this.game.colors = [];
          for (var i = 0; i < this.game.players.length; i++) {
            this.game.colors = this.game.colors.concat(colors.splice(this.rollDice(colors.length) - 1, 1));
          }
        }
        this.game.stats = this.initializeStats();
        console.log('---------------------------');
        console.log('---------------------------');
        console.log('------ INITIALIZE GAME ----');
        console.log('---------------------------');
        console.log('---------------------------');
        this.game.queue.push('init');
        var numPlay = this.game.players.length;
        for (var _i2 = 1; _i2 <= numPlay; _i2++) {
          this.game.queue.push('player_build_road\t' + _i2 + '\t1');
          this.game.queue.push("player_build_city\t".concat(_i2, "\t0"));
        }
        for (var _i3 = numPlay; _i3 >= 1; _i3--) {
          this.game.queue.push('player_build_road\t' + _i3 + '\t1');
          this.game.queue.push("player_build_city\t".concat(_i3, "\t0"));
        }
        this.game.queue.push('initial_placement');
        this.game.queue.push('READY');
        // this is BAD -- do we force a save here in generate map so as not to lose POOL data
        this.game.queue.push('generate_map');
        this.game.queue.push("POOLDEAL\t3\t18\t2");
        this.game.queue.push("POOLDEAL\t2\t19\t1");
        this.game.queue.push("DECKANDENCRYPT\t3\t".concat(numPlay, "\t").concat(JSON.stringify(this.returnDiceTokens())));
        this.game.queue.push("DECKANDENCRYPT\t2\t".concat(numPlay, "\t").concat(JSON.stringify(this.returnHexes())));
        this.game.queue.push("DECKANDENCRYPT\t1\t".concat(numPlay, "\t").concat(JSON.stringify(this.returnDevelopmentCards())));
      }
      if (this.game.players.length > 2) {
        this.grace_window = this.game.players.length * 12;
      } else {
        //2-player game -- make adjustments!

        this.longest.value = 1;
        this.longest.min = 6;
        this.largest.value = 1;
      }
      this.game.playerNames = [];
      for (var _i4 = 0; _i4 < this.game.players.length; _i4++) {
        this.game.playerNames.push(this.app.keychain.returnUsername(this.game.players[_i4]));
      }
      this.game.options.game_length = parseInt(this.game.options.game_length);
      this.turn_limit = parseInt(this.game.options.turn_limit) * 1000;
      if (this.turn_limit) {
        this.clock.useShotClock = true;
      }
    }
  }, {
    key: "initializeState",
    value: function initializeState() {
      var state = {};
      state.hexes = {};
      state.roads = [];
      state.cities = [];
      state.longestRoad = {
        size: 0,
        player: 0,
        path: []
      };
      state.largestArmy = {
        size: 0,
        player: 0
      };
      state.players = [];
      state.ads = [];
      state.playerTurn = 0;
      state.ports = {};
      state.lastroll = [];
      state.placedCity = 'hello world'; //a slight hack for game iniitalization
      state.hasRolled = false;
      state.threatened = [];
      state.robinhood_overlay = 0;
      for (var i = 0; i < this.game.players.length; i++) {
        state.ads.push({});
        state.players.push({});
        state.players[i].resources = [];
        state.players[i].vp = 0;
        state.players[i].towns = 5;
        state.players[i].cities = 4;
        state.players[i].knights = 0;
        state.players[i].vpc = 0;
        state.players[i].devcards = [];
        state.players[i].ports = [];
        state.players[i].road = 0;
      }
      return state;
    }
  }, {
    key: "initializeStats",
    value: function initializeStats() {
      var stats = {};
      stats.dice = {};
      stats.dicePlayer = {};
      stats.production = {};
      stats.discarded = {};
      stats.robbed = {};
      stats.blocked = {};
      stats.banked = {}; // out
      stats.traded = {}; // in
      stats.move_bandit = new Array(this.game.players.length);
      stats.move_bandit.fill(0);
      for (var i = 2; i <= 12; i++) {
        stats.dice[i] = 0;
        var array = new Array(this.game.players.length);
        array.fill(0);
        stats.dicePlayer[i] = array;
      }
      stats.famine = {};
      var _iterator = _createForOfIteratorHelper(this.returnResources()),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var r = _step.value;
          var _array = new Array(this.game.players.length);
          _array.fill(0);
          stats.production[r] = _array;
          stats.discarded[r] = _array.slice();
          stats.robbed[r] = _array.slice();
          stats.blocked[r] = _array.slice();
          stats.banked[r] = _array.slice();
          stats.traded[r] = _array.slice();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      stats.history = [];
      return stats;
    }
  }, {
    key: "returnGameRulesHTML",
    value: function returnGameRulesHTML() {
      return this.rules_overlay.returnRules();
    }
  }, {
    key: "returnAdvancedOptions",
    value: function returnAdvancedOptions() {
      return SettlersGameOptionsTemplate(this.app, this);
    }
  }, {
    key: "endTurn",
    value: function endTurn() {
      this.halted = 0;
      if (this.sleep_timer) {
        clearTimeout(this.sleep_timer);
        this.sleep_timer = null;
      }
      this.clearShotClock();
      this.clock.stopClock();
      this.updateStatus("submitting game move...");
      this.updateControls('WAIT');
      _superPropGet(Settlers, "endTurn", this, 3)([]);
    }
  }, {
    key: "updateControls",
    value: function updateControls(str) {
      if (!this.gameBrowserActive()) {
        return;
      }
      if (str) {
        if (str.includes('<i')) {
          $('.controls .option').css('visibility', 'hidden');
          $('#rolldice').addClass('enabled');
          $('#rolldice').css('visibility', 'visible');
          $('#rolldice').html(str);
          return;
        } else if (str === "WAIT") {
          $('.controls .option').css('visibility', 'hidden');
          $('#rolldice').css('visibility', 'visible');
          $('#rolldice').html("<i class=\"fa-solid fa-pause\"></i>");
          $('#rolldice').removeClass('enabled');
          document.getElementById("rolldice").onclick = null;
          return;
        } else {
          console.log('UPDATE CONTROLS:', str);
          //super.updateControls(str);
        }
      }
      $('.controls .option').css('visibility', 'visible');
      if (this.game.state.playerTurn !== this.game.player) {
        $('#rolldice').html("<i class=\"fa-solid fa-pause\"></i>");
        $('#rolldice').removeClass('enabled');
        document.getElementById("rolldice").onclick = null;
        $('#bank').removeClass('enabled');
        $('#playcard').removeClass('enabled');
        $('#spend').removeClass('enabled');
      }
    }

    // Overwrite inherited function so we can play nice with the specialty HUD controls
  }, {
    key: "updateStatusForGameOver",
    value: function updateStatusForGameOver(status, allowRematch) {
      var _this3 = this;
      var target = this.app.options.homeModule || 'Arcade';
      allowRematch = allowRematch && this.game.player !== 0;
      var options = "<ul>\n                      <li class=\"textchoice\" id=\"confirmit\">Return to ".concat(target, "</li>\n                      ").concat(allowRematch ? '<!--li class="textchoice" id="rematch">Rematch</li-->' : '', "\n                   </ul>");
      this.hud.back_button = false;
      this.updateStatus(status);
      var settlers_self = this;
      $('.controls .option').css('visibility', 'hidden');
      $('.controls .option').removeClass('enabled');
      $('#score').addClass('enabled');
      $('#score').css('visibility', 'visible');
      $('#spend').addClass('enabled');
      $('#spend').html("<i class=\"fa-solid fa-rotate-left\"></i>");
      $('#spend').css('visibility', 'visible');

      // --> return
      $('#rolldice').addClass('enabled');
      $('#rolldice').html("<i class=\"fa-solid fa-door-open\"></i>");
      $('#rolldice').css('visibility', 'visible');
      document.getElementById('rolldice').onclick = function (e) {
        e.currentTarget.onclick = null;
        _this3.exitGame();
      };
      if (document.getElementById('spend')) {
        document.getElementById('spend').onclick = function (e) {
          _this3.initialize_game_run = 0;
          e.currentTarget.onclick = null;
          $("#spend").removeClass('enabled');
          $("#spend").css('visibility', 'hidden');
          _this3.app.connection.emit('arcade-issue-challenge', {
            game: _this3.name,
            players: _this3.game.players,
            options: _this3.game.options
          });
        };
      }

      ////////////////////////////////////////
      // Attach Listeners for rematch actions
      ////////////////////////////////////////
      this.app.connection.on("arcade-challenge-issued", function (tx) {
        var btn = document.getElementById('spend');
        if (btn) {
          if (tx.isFrom(_this3.publicKey)) {
            _this3.updateStatus("Rematch requested");
          } else {
            _this3.updateStatus("Accept Rematch?");
          }
        }
      });
      this.app.connection.on('arcade-game-initialize-render-request', function (game_id) {
        _this3.updateStatus('Preparing rematch...');
        _this3.updateControls("WAIT");
        _this3.browser_active = 0; //Hack to simulate not being in the game mod
      });
      this.app.connection.on('arcade-game-ready-render-request', function (game_details) {
        var status = document.getElementById("status") || document.querySelector(".status");
        status.innerHTML = "<div class=\"player-notice\">Set sail for a new island</div>";
        $('#rolldice').addClass('enabled');
        $('#rolldice').html("<i class=\"fa-solid fa-anchor\"></i>");
        $('#rolldice').css('visibility', 'visible');
        document.getElementById('rolldice').onclick = function (e) {
          e.currentTarget.onclick = null;
          navigateWindow('/' + game_details.slug, 100);
        };
      });
    }
  }]);
}(GameTemplate);
Settlers.importFunctions(SettlersGameLoop, SettlersPlayer, SettlersDisplay, SettlersActions, SettlersState);
module.exports = Settlers;

//<i class="fa-solid fa-hammer"></i>   //<i class="fa-solid fa-screwdriver-wrench"></i>
//<i class="fa-solid fa-dice"></i>
//<i class="fa-solid fa-forward"></i>
//<i class="fa-solid fa-building-columns"></i>

//<i class="fa-solid fa-money-bill-transfer"></i>
//<i class="fa-solid fa-ranking-star"></i>